<script setup lang="ts">
defineProps<{ label?: string }>()
</script>

<template>
  <div class="px-4 pt-3 pb-1">
    <p v-if="label" class="text-xs font-semibold uppercase tracking-wider text-slate-600">
      {{ label }}
    </p>
    <div v-else class="border-t border-slate-800" />
  </div>
</template>
